import { CONTEXT, PARTNER_REFCODE } from "../../configs/constants";
export const showEditDetails = ({ refCode, context }) => {
    // return !isLLa({refCode})
    // return context === CONTEXT.PARTNER
    return true;
};
export const showViewDetails = ({ refCode, context }) => {
    // return !isLLa({refCode})
    return context === CONTEXT.PARTNER;
};
export const showLLABannerCard = ({ refCode }) => {
    return isLLa({ refCode });
};
export const showWithdrawNowCta = ({ refCode, context }) => {
    // return isLLa({refCode}) || context !== CONTEXT.PARTNER
    return context !== CONTEXT.PARTNER;
};
export const isLLa = ({ refCode }) => {
    return refCode === PARTNER_REFCODE.LLA;
};
